export const MAGNITUD_SYMBOLS = {
  152: '%',
  13: 'MWh',
  20: 'MW',
  23: '€/MWh',
};
